export const URLs = {
    main: 'https://f57769194c68.ngrok.io/',
    // main: 'https://6bb9e66f37b9.ngrok.io',
    // whiteBoard: 'https://88ecdfca292a.ngrok.io/boards',
    whiteBoard: "https://14864671912c.ngrok.io/boards"
}

export const getWhiteboardUrl = (meetingId, userId) => `${URLs.whiteBoard}/${meetingId}`;

